import type { HTMLAttributes, ReactNode } from "react"
import { cn } from "@/lib/cn"

// Standard surface card. Two variants:
//   default — dark panel with subtle border + drop shadow
//   inset   — slightly translucent surface for nested content (used inside
//             the SelectedAgentPanel for stats blocks)
export type CardVariant = "default" | "inset"

const VARIANT: Record<CardVariant, string> = {
  default: "rounded-card border border-border bg-app-panel shadow-card",
  inset:   "rounded-control border border-border bg-white/5",
}

type Props = HTMLAttributes<HTMLDivElement> & {
  variant?: CardVariant
  children: ReactNode
}

export function Card({ variant = "default", className, children, ...rest }: Props) {
  return (
    <div {...rest} className={cn(VARIANT[variant], className)}>
      {children}
    </div>
  )
}
